import View from "./View.js";
import previewView from "./previewView.js";
import icons from "url:../../img/BBA25-sprite.svg"; // Parcel 2

class ProductsView extends View {
	_parentElement = document.querySelector(".products");
	_errorMessage = "No products found! Please try again.";
	_message = "";

	_generateMarkup() {
		let markup = `<h2 class="heading-2">Visi pieteiktie produkti</h2>`;

		this._data.categories.forEach((title, id) => {
			const products = this._data.content
				.map(function (result) {
					if (result.categoryID === id) {
						return previewView.render(result, false);
					}
				})
				.join("");

			markup += `
                <div class="container">
					<div class="products__heading">
						<div class="title-brand">
							<svg class="title-brand__icon">
								<use href="${icons}#icon-${this._data.catIcons[id]}"></use>
							</svg>
						</div>
						<h3 class="heading-3">${title}</h3>
					</div>
					<a href="#" class="products__prev" data-scroll="-${this._data.scrollPos}">
						<svg class="products__arrow">
							<use href="${icons}#arrow-left"></use>
						</svg>
					</a>
					<div class="products__wrap">
						<div class="products__current" data-position="0">
							${products}
						</div>
					</div>
					<a href="#" class="products__next" data-scroll="${this._data.scrollPos}">
						<svg class="products__arrow">
							<use href="${icons}#arrow-right"></use>
						</svg>
					</a>
				</div>
        `;
		});

		return markup;
	}

	addHandlerRender(handler) {
		handler();
	}

	_scrollPos(e) {
		const arrowBtn = e.target.closest(".products__prev, .products__next");

		if (!arrowBtn) return;

		e.preventDefault();

		const contentWrap = arrowBtn.classList.contains("products__prev")
			? arrowBtn.nextElementSibling
			: arrowBtn.previousElementSibling;
		const arrowBtnLeft = contentWrap.previousElementSibling;
		const arrowBtnRight = contentWrap.nextElementSibling;

		const content = contentWrap.querySelector(".products__current");

		const contentStyle = getComputedStyle(content);
		const contentGap = parseInt(contentStyle.gap);

		const visibleWidth = content.getBoundingClientRect().width + contentGap;
		const totalWidth = content.scrollWidth;

		let currentX = +content.dataset.position;

		const updateButtons = function () {
			arrowBtnLeft.disabled = currentX === 0;
			arrowBtnRight.disabled = Math.abs(currentX) >= totalWidth - visibleWidth;
			content.dataset.position = currentX;
		};

		function scroll(btn) {
			const remaining = totalWidth - visibleWidth - Math.abs(currentX);

			if (btn.classList.contains("products__next")) {
				const move = Math.min(visibleWidth, remaining + contentGap);
				currentX -= move;
			} else if (btn.classList.contains("products__prev")) {
				const move = Math.min(visibleWidth, Math.abs(currentX));
				currentX += move;
			}
			content.style.transform = `translateX(${currentX}px)`;
			updateButtons();
		}

		scroll(arrowBtn);
	}

	_checkImage(e) {
		const img = e.target.closest(".product-image");
		console.log("ll");
		if (!img) return;

		img.addEventListener("error", () => (this.src = this.src.replace(".jpg", ".png")));
	}

	addHandlerClick() {
		let startX = 0;
		let startY = 0;

		// this._parentElement.addEventListener("touchstart", (e) => {
		// 	startX = e.touches[0].clientX;
		// 	startY = e.touches[0].clientY;
		// });

		// this._parentElement.addEventListener("touchend", this._scrollPos.bind([startX, startY]));
		this._parentElement.addEventListener("click", this._scrollPos);
	}

	addHandlerLoad() {
		this._parentElement.addEventListener("load", this._checkImage);
	}
}

export default new ProductsView();
